var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { C as Component, d as debounce } from "./utilities-Da0sjanJ.js";
class FormFieldValidator extends Component {
  constructor() {
    super();
    __publicField(this, "requiredRefs", ["input", "message"]);
    this.valid = true;
  }
  connectedCallback() {
    super.connectedCallback();
    const { input } = this.refs;
    this.validateField(input, false);
    this._onKeyDown = (event) => {
      if (event.key === "Enter") {
        this.validateField(input, true);
      }
    };
    this._onInput = debounce(() => {
      const isShowingError = !this.refs.messageWrap.classList.contains("hidden");
      if (input.validity.valid) {
        this.validateField(input, false);
      } else if (isShowingError) {
        this.validateField(input, true);
      }
    }, 300);
    this._onBlur = () => this.validateField(input, false);
    this._onSubmit = (event) => {
      const form = event.target;
      if (!form) return;
      const validators = form.querySelectorAll("form-field-validator");
      let allValid = true;
      validators.forEach((v) => {
        var _a;
        const vInput = (_a = v.refs) == null ? void 0 : _a.input;
        if (vInput) v.validateField(vInput, true);
        if (!v.valid) allValid = false;
      });
      if (!allValid) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };
    input.addEventListener("keydown", this._onKeyDown);
    input.addEventListener("input", this._onInput);
    input.addEventListener("blur", this._onBlur);
    if (this.formRoot && !this.formRoot._validatorSubmitBound) {
      this.formRoot.noValidate = true;
      this.formRoot.addEventListener("submit", this._onSubmit);
      this.formRoot._validatorSubmitBound = true;
      this.formRoot._validatorSubmitHandler = this._onSubmit;
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    const { input } = this.refs;
    input.removeEventListener("keydown", this._onKeyDown);
    input.removeEventListener("input", this._onInput);
    input.removeEventListener("blur", this._onBlur);
    if (this.formRoot && this.formRoot._validatorSubmitHandler) {
      this.formRoot.removeEventListener("submit", this.formRoot._validatorSubmitHandler);
      this.formRoot._validatorSubmitBound = false;
    }
  }
  get formRoot() {
    return this.closest("form");
  }
  validateField(input, showMessage = true) {
    var _a, _b;
    const { messageWrap, message } = this.refs;
    let messageText = null;
    this.valid = true;
    let isValid = input.validity.valid;
    if (input.required && input.value.trim() === "") {
      isValid = false;
    }
    const matchId = input.getAttribute("data-match");
    if (matchId && isValid) {
      const matchInput = this.formRoot.querySelector(`#${matchId}`);
      if (matchInput && input.value !== matchInput.value) {
        isValid = false;
        messageText = "Your passwords don't match. Please enter your password again to confirm it.";
      }
    }
    if (!isValid && !messageText) {
      if (input.validity.valueMissing || input.required && input.value.trim() === "") {
        messageText = "This field is required";
      } else if (input.validity.typeMismatch && input.type === "email") {
        messageText = "Invalid email address";
      } else if (input.validity.patternMismatch && (input.type === "password" || ((_a = input.name) == null ? void 0 : _a.includes("password")))) {
        const val = input.value;
        if (val.length < 8) {
          messageText = "Password must be at least 8 characters long";
        } else if (!/[a-z]/.test(val)) {
          messageText = "Password must include a lowercase letter";
        } else if (!/[A-Z]/.test(val)) {
          messageText = "Password must include an uppercase letter";
        } else if (!/[\d\W_]/.test(val)) {
          messageText = "Password must include a number or symbol";
        }
      } else if (input.validity.patternMismatch && ((_b = input.name) == null ? void 0 : _b.includes("phone"))) {
        messageText = "Invalid phone number";
      } else {
        messageText = "Please enter a valid value.";
      }
    }
    this.valid = isValid;
    if (showMessage && !this.valid) {
      if (messageText) message.textContent = messageText;
      input.classList.add("is-error");
      messageWrap.classList.remove("hidden");
    } else {
      input.classList.remove("is-error");
      messageWrap.classList.add("hidden");
    }
  }
}
if (!customElements.get("form-field-validator")) {
  customElements.define("form-field-validator", FormFieldValidator);
}
